import React from 'react';
import { isNil } from 'lodash';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import styles from './styles.module.scss';

const DEFAULT_MAXIMUM_ITEMS_TO_HIDE_SCROLLBAR = 6;

interface IVerticalScrollbar {
  listLength: number;
  maximumItemsToHideScrollbar?: Nullable<number>;
  children: JSX.Element | JSX.Element[];
  universal?: boolean;
}

export interface IHorizontalScrollbar {
  isShown: boolean;
  style: any;
  children: JSX.Element | JSX.Element[];
}

const isHideScrollBar = (
  listLength: number,
  customMaximumItemsToHideScrollbar?: Nullable<number>,
): boolean =>
  isNil(customMaximumItemsToHideScrollbar)
    ? listLength <= DEFAULT_MAXIMUM_ITEMS_TO_HIDE_SCROLLBAR
    : listLength <= customMaximumItemsToHideScrollbar;

export const VerticalScrollbar = ({
  universal = false,
  ...props
}: IVerticalScrollbar) => {
  const trackStyles = classnames(styles['scrollbar-track'], {
    [styles.hide]: isHideScrollBar(
      props.listLength,
      props.maximumItemsToHideScrollbar,
    ),
  });

  return (
    <Scrollbars
      universal={universal}
      autoHeight
      autoHeightMax={170}
      autoHeightMin={170}
      renderTrackVertical={(p: any) => <div {...p} className={trackStyles} />}
      renderTrackHorizontal={(p: any) => (
        <div {...p} style={{ display: 'none' }} />
      )}
      renderThumbVertical={(p: any) => (
        <div {...p} className={styles['scrollbar-thumb']} />
      )}
      renderView={(p: any) => {
        return (
          <div
            {...p}
            style={{
              ...p.style,
              ...(p.style.overflow === 'hidden' ? {} : { overflowX: 'hidden' }),
            }}
          />
        );
      }}
    >
      {props.children}
    </Scrollbars>
  );
};

export const HorizontalScrollbar = (props: IHorizontalScrollbar) => (
  <Scrollbars
    autoHeight
    thumbSize={222}
    thumbMinSize={100}
    style={props.style}
    renderTrackVertical={(p: any) => <div {...p} style={{ display: 'none' }} />}
    renderTrackHorizontal={(p: any) =>
      props.isShown ? (
        <div {...p} className={styles['scrollbar-track-horizontal']} />
      ) : (
        <div {...p} style={{ display: 'none' }} />
      )
    }
    renderThumbHorizontal={(p: any) => (
      <div {...p} className={styles['scrollbar-thumb-horizontal']} />
    )}
    renderView={(p: any) => (
      <div {...p} style={{ width: '100%', overflowX: 'scroll' }} />
    )}
  >
    {props.children}
  </Scrollbars>
);
